var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{attrs:{"buffer-value":_vm.bufferValue,"color":_vm.color,"height":_vm.height,"value":_vm.value,"indeterminate":"","rounded":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }